import papa from "papaparse";

type Parsed = papa.ParseResult<Record<string, string | number | boolean>>[];

export const parseCSV = (file: File): Promise<Parsed> =>
  new Promise((resolve, reject) => {
    papa.parse(file, {
      header: true,
      dynamicTyping: true,
      complete: results => resolve(results.data as Parsed),
      error: error => reject(error.message)
    });
  });

type Base64Result = string | ArrayBuffer | null;

export const convertToBase64 = (file: File): Promise<Base64Result> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
};

export const startFileDownload = (url: string, filename?: string) => {
  const element = document.createElement("a");
  element.href = url;
  element.download = filename || "";
  document.body.appendChild(element);
  element.click();
};

export const createDownloadableFile = (
  text: string,
  filename: string,
  base64 = false
) => {
  const href = base64
    ? `data:application/octet-stream;base64,${text}`
    : URL.createObjectURL(new Blob([text], { type: "text/plain" }));
  startFileDownload(href, filename);
};

export const preventDefaultEvent = (e: MouseEvent) => {
  e.preventDefault();
};

/**
 * Used for drag-and-drop functionality, to prevent the document
 * from consuming the events.
 *
 * Currently used in FileUploads using the DropZone package.
 *
 * Typically is installed in an "onMount" useEffect for the component.
 * example:
 * useEffect(documentPreventDragDropEvents, []);
 */
export const documentPreventDragDropEvents = () => {
  document.addEventListener("dragover", preventDefaultEvent, false);
  document.addEventListener("drop", preventDefaultEvent, false);

  return () => {
    document.removeEventListener("dragover", preventDefaultEvent, false);
    document.removeEventListener("drop", preventDefaultEvent, false);
  };
};
